<div class="step-heading">
  <div class="step-title">
    <button matIconButton type="button" aria-label="Indietro" [disabled]="busy()" (click)="flow.back()">
      <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
    </button>
    <span class="title-medium-emphasized">Consenso GDPR</span>
  </div>
  <button matButton type="button" [disabled]="busy()" (click)="download()">
    <i class="fa-regular fa-arrow-down-to-bracket" aria-hidden="true"></i>
    <span class="label-large">Scarica template</span>
  </button>
</div>

@if (flow.downloading()) {
  <ord-new-customer-preparing />
}

<div class="gdpr-upload">
  <span class="body-large-emphasized">Carica documento firmato{{ consensi() ? ' *' : '' }}</span>
  <ord-new-customer-upload [files]="flow.gdprDocuments()" (filesChange)="flow.gdprDocuments.set($event)" />
</div>

@if (consensi()) {
  <ord-new-customer-banner
    title="Carica modulo consensi GDPR"
    message="Per completare il processo di creazione del nuovo cliente, è obbligatorio caricare il consenso GDPR firmato."
  />
}

<div class="step-actions">
  @if (consensi()) {
    <button matButton="outlined" type="button" [disabled]="busy()" (click)="create(true)">Salta per ora</button>
  }
  <button matButton="filled" type="button" [disabled]="!canContinue()" (click)="create(!consensi() && flow.gdprDocuments().length === 0)">Prosegui</button>
</div>
